module.exports = __webpack_public_path__ + "static/phone.37d72035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/phone.jpg
// module id = 481
// module chunks = 114276838955818